import PropTypes from 'prop-types';
import React from 'react';
import { Grid } from 'semantic-ui-react';
import styles from './CardField.scss';

export default class CardDescriptionList extends React.Component {

  static propTypes = {
    children: PropTypes.node,
    value: PropTypes.node,
    label: PropTypes.string.isRequired,
    className: PropTypes.string
  }

  render() {
    return (
      <div>
        {this.props.value &&
          <Grid className={this.props.className}>
            <Grid.Row className={styles.row}>
              <Grid.Column width={4} textAlign='right' className={styles.descriptionListItem}>
                {this.props.label && `${this.props.label}:`}
              </Grid.Column>
              <Grid.Column width={12} className={styles.descriptionListItem}>
                {this.props.value || this.props.children}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        }
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./webpack/components/Elements/CardField/CardDescriptionList.js